/**
 * Convert string to SEO friendly URL
 * @param {*} url 
 * @returns string
 */
export function routerSeoMapping(url)
{
    return url.toLowerCase().replace(/\s+/g, '-');
}//end routerSeoMapping()
